/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InquiryDto } from '../../models/inquiry-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface InquiryClientControllerSearchV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;
  answerStatus?: ('answered' | 'unanswered') | null;
}

export function inquiryClientControllerSearchV1(http: HttpClient, rootUrl: string, params: InquiryClientControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, inquiryClientControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('answerStatus', params.answerStatus, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<InquiryDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

inquiryClientControllerSearchV1.PATH = '/api/v1/inquiries/client';
